import { inertScript } from "@/utils/insertScript";
import { clearLocalStorageKeepSidebarPinned } from "@/utils/storage";
import PackageLimitDialog from "@/components/globalDialog/PackageLimitDialog.vue";
import PackageLockedDialog from "@/components/globalDialog/PackageLockedDialog.vue";
import WhatsAppBalanceInsufficientDialog from "@/components/globalDialog/WhatsAppBalanceInsufficientDialog.vue";
import { isHiddenOnCurrentDomain } from "@/utils/menuVisible";
export default {
  name: "App",
  components: {
    PackageLimitDialog,
    PackageLockedDialog,
    WhatsAppBalanceInsufficientDialog
  },
  data() {
    return {
      fillPageRoutes: ["/chatBotInsertion", "/chatBotInsertError"]
    };
  },
  beforeCreate() {
    const host = window.location.host;
    let appName = "";
    if (isHiddenOnCurrentDomain(['joincompassai.com', 'joincompassai.emkol.cn']) || host === 'localhost:8089') {
      appName = "JoinCompassAi";
    } else {
      appName = "JoinMC";
    }
    this.$store.commit("SET_APP_NAME", appName);
  },
  created() {
    const token = this.$store.getters["authoState/token"];
    const user_info = this.$store.getters["authoState/user_info"];
    if (token && !user_info.curr_team_id) {
      this.$store.commit("authoState/CLEAR_AUTH_STATE");
      clearLocalStorageKeepSidebarPinned();
    }
  },
  beforeMount() {
    inertScript();
  }
  /*watch: {
    "$route.path": {
      immediate:true,
      handler(path) {
        const script = document.getElementById('bd-script');
        const NODE_ENV = process.env.NODE_ENV;
        const isMcInsertPages = this.fillPageRoutes.includes(path);
        if (NODE_ENV !== "production") {
          if (script) {
            script.remove();
          }
          return;
        }
        if (isMcInsertPages) {
          script.src = "https://hm.baidu.com/hm.js?ad9d540f2174b878cf0451bfb8a60d41";
        } else {
          script.src = "https://hm.baidu.com/hm.js?d0d23e67fc83bb251ade89d690021e8c"
        }
      }
    }
  }*/
};